import { render } from "./AlzataOdataTable.vue?vue&type=template&id=24a19c28"
import script from "./AlzataOdataTable.vue?vue&type=script&lang=js"
export * from "./AlzataOdataTable.vue?vue&type=script&lang=js"

import exportComponent from "C:\\stuff\\dfob\\adminui\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__